<template>
  <div class="table-wrapper">
      <div class="table-title py-2 px-3">
        <h6>{{ title }}</h6>
      </div>
      <hr style="margin: 0" />
      <div class="row table-header m-0">
        <div class="col-4 py-2 px-3 m-0">
          <p class="m-0">Permission</p>
        </div>
        <div class="col-2 py-2 px-3">
          <p class="m-0">Read</p>
        </div>
        <div class="col-2 py-2 px-3">
          <p class="m-0">Create</p>
        </div>
        <div class="col-2 py-2 px-3">
          <p class="m-0">Update</p>
        </div>
        <div class="col-2 py-2 px-3">
          <p class="m-0">Delete</p>
        </div>
      </div>
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: "TableWrapper",
  props: {
    title: {
      type: String,
      default: "Table Title",
      required: true,
    },
  },
}
</script>

<style scoped>
.table-wrapper {
  border: 1px solid #cfd3d9;
  border-radius: 8px;
  overflow: hidden;
}
.table-title {
  background-color: #f8f9fa;
}

.table-title h6 {
  margin: 0;
}

.table-header p {
  font-weight: 600;
  font-size: 14px;
  color: #374151;
}

.table-header {
  background-color: #e6f3fe;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Components/RolesAndPermissions/TableWrapper.vue